import _slicedToArray from "/opt/buildhome/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
export default function getJSXPragmaInfo(options) {
  var _splitPragma = splitPragma(options.jsxPragma || "React.createElement"),
    _splitPragma2 = _slicedToArray(_splitPragma, 2),
    base = _splitPragma2[0],
    suffix = _splitPragma2[1];
  var _splitPragma3 = splitPragma(options.jsxFragmentPragma || "React.Fragment"),
    _splitPragma4 = _slicedToArray(_splitPragma3, 2),
    fragmentBase = _splitPragma4[0],
    fragmentSuffix = _splitPragma4[1];
  return {
    base: base,
    suffix: suffix,
    fragmentBase: fragmentBase,
    fragmentSuffix: fragmentSuffix
  };
}
function splitPragma(pragma) {
  var dotIndex = pragma.indexOf(".");
  if (dotIndex === -1) {
    dotIndex = pragma.length;
  }
  return [pragma.slice(0, dotIndex), pragma.slice(dotIndex)];
}